import { HTMLAttributes, FC } from "react";
import { useStyles } from "./PopupAddHomeScreen.style";
import {
  Dialog,
  Typography,
  Image,
  Icon,
  TypographyVariant,
  TypographyColor,
} from "@onmo/ui";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { removePopupQueue } from "../../../slices/popup";
import { PopupType } from "../../../constants/popup";
import ExportIcon from "../../../assets/settings/export.webp";
import ExportIcon2x from "../../../assets/settings/export@2x.webp";
import ExportIcon3x from "../../../assets/settings/export@3x.webp";
import { useTranslation } from "react-i18next";

export const PopupAddHomeScreen: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  const { currentPopupId } = useAppSelector((state) => state.popup);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  return (
    <Dialog
      className={classes.root}
      mainAction={{
        text: t("ok"),
        onClick: () =>
          dispatch(removePopupQueue({ type: PopupType.AddHomeScreen })),
      }}
      open={currentPopupId === PopupType.AddHomeScreen}
    >
      <div className={classes.content}>
        <Typography
          variant={TypographyVariant.BodyB3Bold}
          color={TypographyColor.Text1}
        >
          {t("add_to_home_screen")}
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB6Regular}
          color={TypographyColor.Text1}
          className={classes.label}
        >
          {t("add_to_home_screen_description")}
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB6Regular}
          color={TypographyColor.Text1}
        >
          {t("add_to_home_screen_step1")}{" "}
          <Image
            src={ExportIcon}
            src2x={ExportIcon2x}
            src3x={ExportIcon3x}
            className={classes.exportIcon}
          />{" "}
          {t("btn_text_below_screen_step1")}
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB6Regular}
          color={TypographyColor.Text1}
        >
          {t("add_to_home_screen_step2")}
          <Icon name="icon-linear-add-square" className={classes.addIcon} />
        </Typography>
      </div>
    </Dialog>
  );
};
